import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from '@/components/HomePage';
import { FeedPage } from '@/pages/FeedPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/feed/:zipcode" element={<FeedPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
